/**
 * feature-config flag names owned by Design Experience
 *
 * please consider removing this file and adding it to an appropriate place in the
 * feature code (e.g. an entrypoint, or a package owned by the feature team), or
 * passing flag names directly as a string!
 *
 * by separating it out, we decouple the feature code from the feature config packages
 * and avoid the need to update this package when flags are added or removed.
 */

export const DESIGN_EXPERIENCE_FLAG_NAMES = {
  LIGHTSABER_PRELOADER: 'ff-desux-lightsaber-preloader',
  ALIGN_TAG: 'ff-grow-4084-align-tag',
  CANVAS_MULTI_SELECT: 'ff-desux-8790-multi-select',
  CHROME_122_DRAG_AND_DROP_NAVIGATOR_PATCH:
    'ff-desux-7544-chrome-drag-and-drop-canvas-logic',
  CUSTOM_CODE_UX: 'ff-desux-7988-custom-code-ux',
  DASHBOARD_SITE_SETTINGS_BUTTONS: 'ff-desux-open-site-button',
  NAVIGATOR_REFACTOR: 'ff-desux-9969-navigator-refactor',
  ON_CANVAS_SIZING_CONTROLS: 'ff-on-canvas-sizing-controls',
  SAFARI_17_2_DRAG_AND_DROP_PATCH:
    'ff-desux-7544-safari-drag-and-drop-canvas-logic',
  LOTTIE_SPLINE_PERFORMANCE: 'ff-styl-ix3-lottie-spline-performance',
  OPEN_CANVAS_DEBUGGER: 'ff-canv-2303-open-canvas-debugger',
  REALTIME_AGENT_PRESENCE: 'ff-rea-61-realtime-agent-presence',
  VIRTUALIZED_PAGE_LIST: 'ff-virtualized-page-list',
};
